if (!customElements.get('swiper-component')) {
  class SwiperComponent extends HTMLElement {

    constructor() {
      super();
      this.swiperButtons = this.querySelector('[data-swiper-buttons]');
      this.swiperPagination = this.querySelector('[data-swiper-pagination]');
      this.swiperButtonPrev = this.querySelector('[data-swiper-button-prev]');
      this.swiperButtonNext = this.querySelector('[data-swiper-button-next]');
      this.settings = {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 32,
        speed: 400,
        loop: false,
        init: false,
        navigation: {
          prevEl: this.swiperButtonPrev,
          nextEl: this.swiperButtonNext
        },
        pagination: {
          el: this.swiperPagination,
          type: "bullets"
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: this.dataset.items - 2,
          },
          992: {
            slidesPerView: this.dataset.items - 1,
          },
          1200: {
            slidesPerView: this.dataset.items,
          }
        }
      }
      Object.keys(this.settings.breakpoints).forEach(key => {
        key = parseFloat(key);
        if (window.innerWidth > key) {
          this.currentBreakpoint = this.settings.breakpoints[key];
        }
      });
      if (this.hasAttribute('data-collection-products')) {
        this.productSize = parseFloat(this.getAttribute('data-collection-products'));
      }
    }

    connectedCallback() {

      /**
       * Load virtual skeleton slides if no collection products from liquid are present
       */
      if (this.hasAttribute('data-skus')) {
        this.settings.virtual = {
          slides: (() => Array.from({ length: 3 }).map(() => `<div class="skeleton-product-card"></div>`))(),
          cache: false
        }
      }

      this.swiper = new Swiper(this, this.settings);

      if (this.productSize <= this.currentBreakpoint.slidesPerView) {
        this.swiper.params.preventClicks = false;
        this.swiper.preventClicks = false;
        this.swiper.params.preventClicksPropagation = false;
        this.swiper.preventClicksPropagation = false;
        this.swiperButtons.setAttribute('hidden', '');
      }

      this.swiper.init();

      /**
       * Fetch SKU Products from data-attribute
       */
      if (this.hasAttribute('data-skus')) {
        this.fetchSKUS(this.getAttribute('data-skus'));
      }

    }

    fetchSKUS(skus) {
      try {
        skus = JSON.parse(skus);
        if (skus.length) {
          skus = skus.map(sku => `variants.sku:${sku}\*`);
          let url;
          if (this.hasAttribute('data-locale')) {
            url = new URL(`${window.location.origin}/${this.getAttribute('data-locale')}/search`);
          } else {
            url = new URL(`${window.location.origin}/search`);
          }
          url.search = new URLSearchParams({ q: skus.join(' OR '), type: "product", view: `sku` }).toString();
          fetch(url).then(r => r.json()).then(r => this.parseResults(r));
        }
      } catch (error) {
        console.log(error)
      }
    }

    /**
     * 
     * Interprets the result of the search fetch and replaces all virtual skeleton loading slides of swiper
     * 
     * @param {Object} r 
     */
    parseResults(r) {
      if (r && r.results_count > 0) {
        const slides = [];
        r.results.forEach(product => {
          const slideHtml = new DOMParser().parseFromString(product.cardHtml, 'text/html').querySelector('body').innerHTML;
          slides.push(slideHtml);
        });
        this.swiper.virtual.slides = slides;
        this.swiper.virtual.update(true);
      } else {
        this.closest('.shopify-section').remove();
      }
    }

  }

  customElements.define('swiper-component', SwiperComponent);

}
